import { logger } from "./logger/logger";

const QUERY_STRING_INSTALL_TYPE = "installType";
const QUERY_STRING_LAYOUT = "layout";
const QUERY_VALUE_LANDING = "landing";

export const InstallTypes = {
  landingPage: "landing_page",
  cdnNoIframe: "cdn_no_iframe",
  cdnInlineIframe: "cdn_inline_iframe",
  cdnModalIframe: "cdn_modal_iframe",
  programBuilderPreview: "program_builder_preview",
} as const;

export type InstallType = (typeof InstallTypes)[keyof typeof InstallTypes];

let declaredInstallType: InstallType | undefined;

/**
 * Declare the install context from an install wrapper that mounts the form into
 * the host page, where there is no iframe URL to carry the install type as a
 * query string param.
 */
export const setInstallType = (installType: InstallType): void => {
  declaredInstallType = installType;
};

export const getInstallType = (): InstallType | string => {
  if (declaredInstallType) {
    return declaredInstallType;
  }

  try {
    const parsed: URLSearchParams = new URLSearchParams(window.location.search);

    const installTypeParam = parsed.get(QUERY_STRING_INSTALL_TYPE);
    if (installTypeParam) {
      return decodeURIComponent(installTypeParam);
    }

    if (parsed.get(QUERY_STRING_LAYOUT) === QUERY_VALUE_LANDING) {
      return InstallTypes.landingPage;
    }
  } catch (e) {
    logger.error(e, "getInstallType");
  }

  return InstallTypes.cdnNoIframe;
};
